import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { Form, Modal, Select } from "antd";
import SkeletonTable from "../../../components/table/SkeletonTable";
import columns from "../../../columns/files/reviewfile";
import BackButton from "../../../components/button/BackButton";
import { SubmitFileApi } from "../../../api/request/service";
import LoadableButton from "../../../components/button/LoadableButton";
import Edit from "../../../assets/Edit";
import ViewFilesModal from "./ViewFilesModal";
import ModalComponent from "../../../components/modals/ModalComponent";

const ReviewSubmittedFile = () => {
  const { state } = useLocation();
  const { id } = useParams();
  const [FrequencyForm] = Form.useForm();
  const navigate = useNavigate();
  const [data, setData] = useState(state?.data || []);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isFilesOpen, setIsFilesOpen] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState({});
  const [isFrequencyOpen, setIsFrequencyOpen] = useState(false);
  const [selectedFrequency, setSelectedFrequency] = useState(null);

  const handleCheck = () => {
    state?.sectionData?.is_bookkeeping
      ? setIsFrequencyOpen(true)
      : handleSubmit();
  };

  const handleSubmit = async () => {
    try {
      setIsLoadingSubmit(true);
      let params = {
        file_id: id,
        ...(state?.sectionData?.is_bookkeeping && selectedFrequency
          ? { frequency_type: selectedFrequency }
          : {}),
      };

      const { data } = await SubmitFileApi(params);
      if (data?.status) navigate("/files", { state: { status: "inprocess" } });
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  const frequency = [
    {
      value: "Weekly",
      label: "Weekly",
    },
    {
      value: "Monthly",
      label: "Monthly",
    },
    {
      value: "Quarterly",
      label: "Quarterly",
    },
    {
      value: "SixMonthly",
      label: "SixMonthly",
    },
    {
      value: "Yearly",
      label: "Yearly",
    },
  ];

  useEffect(() => {
    if (state?.data?.length) setIsOpen(true);
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setData(
      state?.data?.map((item) => {
        return {
          ...item,
          questions: item?.questions?.map((question) => ({
            ...question,
            ...(question?.documents?.length > 0 && {
              response_text: (
                <a
                  className="text-blue-500"
                  onClick={() => {
                    setSelectedQuestion(question);
                    setIsFilesOpen(true);
                  }}
                >
                  View Files
                </a>
              ),
            }),
          })),
        };
      })
    );
  }, [state?.data]);

  useEffect(() => {
    if (isFrequencyOpen) FrequencyForm?.resetFields();
  }, [isFrequencyOpen]);

  return (
    <>
      <div className="bg-white border rounded-xl p-5">
        <div className="flex items-center mb-5 justify-between">
          <div className="flex items-center gap-3">
            <BackButton />
            <h2 className="title">Review & Confirm</h2>
          </div>
          <div className="flex items-center justify-between gap-3">
            <LoadableButton
              lable="Edit"
              onClick={() => navigate(-1)}
              className="!px-4"
            >
              <Edit color="#fff" className="!size-4" /> Edit
            </LoadableButton>

            <LoadableButton
              type="submit"
              lable="Submit"
              onClick={handleCheck}
              isLoading={isLoadingSubmit}
              loadingLable="Submitting File..."
            />
          </div>
        </div>
        {data?.map((item, index) => (
          <div className="table-radius-0 text-light mb-10">
            <p className="title text-primary mb-5">
              {`Section ${index + 1}:`} {item?.section_name}
            </p>
            <SkeletonTable
              columns={columns}
              data={item?.questions}
              pagination={false}
            />
          </div>
        ))}
      </div>

      <Modal
        open={isOpen}
        closeIcon={false}
        footer={false}
        maskClosable={false}
        keyboard={false}
        width={650}
        centered
      >
        <div className="text-center mt-6 md:mt-10">
          <p className="text-lg md:text-2xl font-semibold text-gray-800 mb-4">
            Submission Review
          </p>
          <div className="space-y-3">
            <p className="text-base md:text-lg font-medium text-gray-700">
              Please review your information before final submission.
            </p>
            <p className="text-sm md:text-base text-gray-600">
              Double-check all the details to ensure everything is accurate,
              <br className="hidden md:block" />
              then click{" "}
              <span className="font-semibold text-gray-800">Submit</span> to
              proceed.
            </p>
          </div>
        </div>

        <div className="text-center mt-6">
          <LoadableButton
            lable="OK"
            className="!px-6 !py-2 !text-sm md:!text-base !font-semibold"
            onClick={() => setIsOpen(false)}
          />
        </div>
      </Modal>

      <ViewFilesModal
        isOpen={isFilesOpen}
        setIsOpen={setIsFilesOpen}
        question={selectedQuestion}
      />

      <ModalComponent
        isOpen={isFrequencyOpen}
        setIsOpen={setIsFrequencyOpen}
        title="Select Frequency"
        width={500}
        onCancel={() => setIsFrequencyOpen(false)}
      >
        <Form form={FrequencyForm} onFinish={handleSubmit}>
          <Select
            placeholder="Select Frequency"
            onChange={(value) => setSelectedFrequency(value)}
            className="!w-full"
          >
            {frequency?.map((item, index) => (
              <Select.Option key={index} value={item?.value}>
                {item?.label}
              </Select.Option>
            ))}
          </Select>

          <div className="text-center mt-10">
            <LoadableButton
              type="submit"
              lable="Submit"
              loadingLable="Submitting..."
              isLoading={isLoadingSubmit}
            />
          </div>
        </Form>
      </ModalComponent>
    </>
  );
};

export default ReviewSubmittedFile;
